/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/customer-special-price-response.ts.
 */
import {CustomerSpecialPrice} from './customer-special-price';

/**
 * Zweck: Beschreibt class CustomerSpecialPriceResponse und ihren Daten- oder Funktionsvertrag.
 */
export class CustomerSpecialPriceResponse {
  VerrechnungsPreiscodeKunde: string;
  SonderpreiseKunde: CustomerSpecialPrice[];
}
